import { InjectionToken } from '@angular/core';

export interface TaskCounts {
  tasksToPlan: number;
  parentTasksUpcoming: number;
  subTasksToday: number;
  tasksDoneToday: number;
}

export enum TaskCountType {
  TASKS_TO_PLAN = 'TASKS_TO_PLAN',
  PARENT_TASKS_UPCOMING = 'PARENT_TASKS_UPCOMING',
  SUBTASKS_TODAY = 'SUBTASKS_TODAY',
  TASKS_DONE_TODAY = 'TASKS_DONE_TODAY',
}

export interface TaskCountConfig {
  homiApiUrl: string;
}

export const TASK_COUNT_CONFIG: InjectionToken<TaskCountConfig> =
  new InjectionToken<TaskCountConfig>('TASK_COUNT_CONFIG');
